export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5931.d21f9dad.jpg";